import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { palette } from "../../../../assets/styles/Palette";
import {
  Body1,
  Body2,
  Body3,
  Sub2,
} from "../../../../assets/styles/Typography";
import MoleculeContentPopup from "../molecules/MoleculeContentPopup";
import MoleculeContentSettingPopup from "../molecules/MoleculeContentSettingPopup";
import images from "../../../../assets/styles/Images";
import { Button } from "../../../../assets/styles/ButtonStyle";
import { BoxWrap } from "../../../../assets/styles/BusinessAnalysisStyle";
import PopupWrap from "../../../../assets/styles/Popup";
import { useAtom } from "jotai";
import { IS_LOGGED_IN } from "../../../AtomStates";
import { getEduViewDetailOnServer } from "../../../../utils/indexedDB";
import OrganismDisplayViewEduPreview from "../../../Global/components/organisms/OrganismDisplayViewEduPreview";
import OrganismDisplayViewEduMealPreview from "../../../Global/components/organisms/OrganismDisplayViewEduMealPreview";

const OrganismContentList = ({
  contentList = [],
  lotationDetail = null,
  onLotationUpdate = null,
}) => {
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [selectedTab, setSelectedTab] = useState("전학년");
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [contentToDelete, setContentToDelete] = useState(null);
  const [scheduledContents, setScheduledContents] = useState({
    gradeAll: [],
    grade1: [],
    grade2: [],
    grade3: [],
  });

  // 미리보기 관련 state
  const [showTemplatePreview, setShowTemplatePreview] = useState(false);
  const [templateToPreview, setTemplateToPreview] = useState(null);
  const [previewJsonData, setPreviewJsonData] = useState(null);
  const [previewMarkdownData, setPreviewMarkdownData] = useState(null);
  const [previewTitleData, setPreviewTitleData] = useState(null);
  const [previewContentsPurpose, setPreviewContentsPurpose] = useState(null);
  const [previewWidth, setPreviewWidth] = useState(0);
  const [previewHeight, setPreviewHeight] = useState(0);
  const [previewContentsDesignConcept, setPreviewContentsDesignConcept] =
    useState(null);
  const [previewMealData, setPreviewMealData] = useState(null);
  const [previewNoticeText, setPreviewNoticeText] = useState("");
  const [contentsTypeState, setContentsTypeState] = useState(null);

  // 복사 성공 팝업 관련 state
  const [showCopySuccessPopup, setShowCopySuccessPopup] = useState(false);
  const [copiedInfo, setCopiedInfo] = useState({ type: "", content: "" });

  // 콘텐츠 설정 팝업 관련 state
  const [showContentSettingPopup, setShowContentSettingPopup] = useState(false);

  const tabs = ["전학년", "1학년", "2학년", "3학년"];

  // 탭별 링크 생성 함수
  const generateDirectLink = () => {
    const baseId = lotationDetail.viewId || lotationDetail._id;
    // const basePath = `/AutodisplayViewLinkEduLotation/${baseId}`;
    const basePath = `/AutodisplayViewLinkEduMobileLotation/${baseId}`;

    switch (selectedTab) {
      case "전학년":
        return `${window.location.host}${basePath}-all`;
      case "1학년":
        return `${window.location.host}${basePath}-grade1`;
      case "2학년":
        return `${window.location.host}${basePath}-grade2`;
      case "3학년":
        return `${window.location.host}${basePath}-grade3`;
      default:
        return `${window.location.host}${basePath}-all`;
    }
  };

  // 클립보드 복사 함수
  const handleCopyToClipboard = async (content, type) => {
    try {
      await navigator.clipboard.writeText(content);
      setCopiedInfo({ type, content });
      setShowCopySuccessPopup(true);
    } catch (error) {
      console.error("복사 실패:", error);
      // 복사 실패 시에도 사용자에게 알림
      setCopiedInfo({ type: "오류", content: "복사에 실패했습니다." });
      setShowCopySuccessPopup(true);
    }
  };

  // lotationDetail에서 편성된 콘텐츠 데이터 로드
  const loadScheduledContents = () => {
    try {
      if (lotationDetail) {
        const parsedData = {
          gradeAll: lotationDetail.gradeAll || [],
          grade1: lotationDetail.grade1 || [],
          grade2: lotationDetail.grade2 || [],
          grade3: lotationDetail.grade3 || [],
        };
        setScheduledContents(parsedData);
        console.log(
          "Loaded scheduled contents from lotationDetail:",
          parsedData
        );
      }
    } catch (error) {
      console.error(
        "Failed to load scheduled contents from lotationDetail:",
        error
      );
    }
  };

  // 편성된 콘텐츠 필터링 (테이블에 표시용)
  const getFilteredScheduledContentList = () => {
    if (selectedTab === "전학년") {
      return scheduledContents.gradeAll || [];
    } else if (selectedTab === "1학년") {
      return scheduledContents.grade1 || [];
    } else if (selectedTab === "2학년") {
      return scheduledContents.grade2 || [];
    } else if (selectedTab === "3학년") {
      return scheduledContents.grade3 || [];
    }
    return [];
  };

  // 편성 팝업용 콘텐츠 필터링 (contentsTarget 기준)
  const getFilteredContentListForPopup = () => {
    if (selectedTab === "전학년") {
      return contentList.filter(
        (content) =>
          content.contentsTarget === "전교생" ||
          content.designConcept === "happy" ||
          content.designConcept === "healthy"
      );
    }
    const target = `${selectedTab} 학생`;
    return contentList.filter((content) => content.contentsTarget === target);
  };

  const getConceptName = (conceptId) => {
    switch (conceptId) {
      case "concept1":
        return "피치 블룸";
      case "concept2":
        return "라벤더 크림";
      case "concept3":
        return "민트 브리즈";
      case "concept4":
        return "옐로우 모먼트";
      case "concept5":
        return "클래식 브론즈";
      case "concept6":
        return "레트로 블루";
      case "concept7":
        return "모던 엣지";
      case "concept8":
        return "테크 블랙";
      case "concept9":
        return "프레시 네이비";
      case "happy":
        return "행복식";
      case "healthy":
        return "건강식";
      default:
        return "기본 테마";
    }
  };

  const handleAddContent = () => {
    setIsPopupOpen(true);
  };

  const handleContentSetting = () => {
    setShowContentSettingPopup(true);
  };

  const handleCloseContentSettingPopup = () => {
    setShowContentSettingPopup(false);
  };

  const handleClosePopup = async () => {
    setIsPopupOpen(false);
    // 팝업이 닫힐 때 lotationDetail을 새로고침하여 최신 편성 상태를 반영
    if (onLotationUpdate) {
      await onLotationUpdate();
    }
  };

  // designConcept에 따른 이미지 반환 함수
  const getDesignConceptImage = (conceptId) => {
    switch (conceptId) {
      case "healthy":
        return "healthy";
      case "happy":
        return "happy";
      default:
        return "healthy";
    }
  };

  const handleTemplatePreview = async (contentId) => {
    try {
      // 서버에서 최신 데이터 가져오기
      const latestContent = await getEduViewDetailOnServer(
        contentId,
        isLoggedIn
      );
      console.log("🚀 ~ latestContent:", latestContent);

      if (latestContent.contentsType === "meal") {
        setPreviewMealData(latestContent.contentGeneratorMeal);
        setPreviewNoticeText(latestContent.nutritionMessage);
      } else {
        setPreviewJsonData(latestContent.contentGeneratorJson);
        setPreviewMarkdownData(latestContent.contentGeneratorMarkdown);
        setPreviewTitleData(latestContent.contentGeneratorTitle);
        setPreviewContentsPurpose(latestContent.contentsPurpose);
        setPreviewContentsDesignConcept(latestContent.designConcept);
      }

      setPreviewWidth(parseInt(latestContent.viewDevice.deviceWidth));
      setPreviewHeight(parseInt(latestContent.viewDevice.deviceHeight));

      setContentsTypeState(latestContent.contentsType);

      setTemplateToPreview({
        category: latestContent.designConcept,
        title: latestContent.dataAnalysis?.title,
        customer: latestContent.customer,
        image: getDesignConceptImage(latestContent.designConcept),
      });
      setShowTemplatePreview(true);
    } catch (error) {
      console.error("미리보기 데이터 로딩 실패:", error);

      // 에러 시 기존 로컬 데이터 사용
      const content = contentList.find((c) => c._id === contentId);
      if (content) {
        if (content.contentsType === "meal") {
          setPreviewMealData(content.contentGeneratorMeal);
          setPreviewNoticeText(content.nutritionMessage);
        } else {
          setPreviewJsonData(content.contentGeneratorJson);
          setPreviewMarkdownData(content.contentGeneratorMarkdown);
          setPreviewTitleData(content.contentGeneratorTitle);
          setPreviewContentsPurpose(content.contentsPurpose);
          setPreviewContentsDesignConcept(content.designConcept);
        }

        if (content?.viewDevice) {
          setPreviewWidth(parseInt(content.viewDevice.deviceWidth));
          setPreviewHeight(parseInt(content.viewDevice.deviceHeight));
        }

        setTemplateToPreview({
          category: content.designConcept,
          title: content.dataAnalysis?.title,
          customer: content.customer,
          image: getDesignConceptImage(content.designConcept),
        });
        setShowTemplatePreview(true);
      }
    }
    // 창 history 스택에 현재 창 상태를 저장하고 미리보기 창을 추가
    window.history.replaceState({ page: "page" }, "", window.location.pathname);
    window.history.pushState({ overlay: true }, "", "?preview");
  };

  const handleCloseTemplatePreview = () => {
    setShowTemplatePreview(false);
    setTemplateToPreview(null);
    window.history.replaceState({ page: "page" }, "", window.location.pathname);
  };

  const handleOpenPopup = (contentId) => {
    console.log("활성화 설정:", contentId);
    alert(`활성화 설정 팝업이 여기에 연결됩니다: ${contentId}`);
  };

  const handleEditTitle = (content) => {
    console.log("제목 수정:", content);
    alert(`제목 수정 팝업이 여기에 연결됩니다: ${content.dataAnalysis?.title}`);
  };

  const handleDeleteContent = (contentId) => {
    console.log("콘텐츠 삭제:", contentId);
    alert(`${contentId}가 삭제되었습니다.`);
    setShowConfirmPopup(false);
    setContentToDelete(null);
  };

  const filteredScheduledContentList = getFilteredScheduledContentList();
  const filteredContentListForPopup = getFilteredContentListForPopup();

  // 컴포넌트 마운트 시 lotationDetail에서 편성된 콘텐츠 로드
  useEffect(() => {
    loadScheduledContents();
  }, [lotationDetail]);

  // 미리보기 창에서 뒤로가기를 누르면 대시보드 창으로 돌아가도록 설정
  useEffect(() => {
    const handlePopState = (e) => {
      if (!e.state?.overlay) {
        setShowTemplatePreview(false);
        setTemplateToPreview(null);
      }
      // 전체화면 해제
      if (document.fullscreenElement) {
        document.exitFullscreen().catch((err) => {
          console.log("전체화면 해제 실패:", err);
        });
      }
    };
    window.addEventListener("popstate", handlePopState);
    return () => window.removeEventListener("popstate", handlePopState);
  }, []);

  return (
    <>
      <Container>
        <Header>
          <HeaderLeft>
            <TabContainer>
              {tabs.map((tab) => (
                <Tab
                  key={tab}
                  active={selectedTab === tab}
                  onClick={() => setSelectedTab(tab)}
                >
                  {tab}
                </Tab>
              ))}
            </TabContainer>
            {lotationDetail && (
              <DirectLinkContainer>
                <StyledFrame>
                  <div>
                    <StyledIdSpan01>다이렉트 링크 : </StyledIdSpan01>
                    <StyledIdSpan02
                      onClick={() => {
                        const url = `http://${generateDirectLink()}`;
                        window.open(url, "_blank");
                      }}
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "#007bff",
                      }}
                    >
                      {selectedTab}
                      {/* {generateDirectLink()} */}
                    </StyledIdSpan02>
                  </div>

                  <CopyButton
                    onClick={() =>
                      handleCopyToClipboard(
                        generateDirectLink(),
                        "다이렉트 링크"
                      )
                    }
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M16 1H4C2.9 1 2 1.9 2 3V17H4V3H16V1ZM19 5H8C6.9 5 6 5.9 6 7V21C6 22.1 6.9 23 8 23H19C20.1 23 21 22.1 21 21V7C21 5.9 20.1 5 19 5ZM19 21H8V7H19V21Z"
                        fill="#9CA3AF"
                      />
                    </svg>
                  </CopyButton>
                </StyledFrame>
              </DirectLinkContainer>
            )}
          </HeaderLeft>
          <HeaderRight>
            <StyledContentButton onClick={handleContentSetting}>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
              >
                <circle
                  cx="10.11"
                  cy="10.11"
                  r="7.11"
                  stroke="#256EF4"
                  strokeWidth="1.5"
                />
                <line
                  x1="9.89549"
                  y1="6.4099"
                  x2="9.89549"
                  y2="10.1839"
                  stroke="#256EF4"
                  strokeWidth="1.86911"
                  strokeLinecap="round"
                />
                <line
                  x1="11.8236"
                  y1="11.5456"
                  x2="9.92994"
                  y2="10.1967"
                  stroke="#256EF4"
                  strokeWidth="1.86911"
                  strokeLinecap="round"
                />
              </svg>
              <Sub2 color="primary">편성 시간 설정</Sub2>
            </StyledContentButton>
            <StyledContentButton onClick={handleAddContent}>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.154 2.99902H4.78352C4.14301 2.99902 3.62378 3.51826 3.62378 4.15876V16.5293C3.62378 17.1698 4.14301 17.689 4.78352 17.689H17.154C17.7945 17.689 18.3138 17.1698 18.3138 16.5293V4.15876C18.3138 3.51826 17.7945 2.99902 17.154 2.99902Z"
                  stroke="#256EF4"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M14.1474 9.39274L15.1005 10.3458L14.1474 11.2989M7.79353 9.39274L6.84045 10.3458L7.79353 11.2989M11.9235 7.1689L10.9705 6.21582L10.0174 7.1689M11.9235 13.5227L10.9705 14.4758L10.0174 13.5227"
                  stroke="#256EF4"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <Sub2 color="primary">콘텐츠 활성화 설정</Sub2>
            </StyledContentButton>
          </HeaderRight>
        </Header>

        <ContentListWrap>
          {filteredScheduledContentList.length === 0 ? (
            <BoxWrap NoData style={{ height: "300px" }}>
              <img src={images.ListFillPrimary} alt="" />
              <Body2 color="gray700" align="center !important">
                편성된 콘텐츠가 없습니다.
              </Body2>
            </BoxWrap>
          ) : (
            <Table>
              <colgroup>
                <col width="68%" />
                <col width="18%" />
                <col width="14%" />
              </colgroup>
              <TableHeader>
                <tr>
                  <th>
                    <Body1 color="gray700" align="left">
                      콘텐츠 제목
                    </Body1>
                  </th>
                  <th>
                    <Body1 color="gray700" align="left">
                      제작일
                    </Body1>
                  </th>
                  <th>
                    <Body1 color="gray700" align="left">
                      콘텐츠 설정
                    </Body1>
                  </th>
                </tr>
              </TableHeader>
              <TableBody>
                {filteredScheduledContentList.map((content) => (
                  <tr key={content._id}>
                    <td>
                      <ContentNameCell>
                        <div
                          style={{
                            fontSize: "20px",
                            fontFamily: "Pretendard",
                            fontWeight: "700",
                            color: "#323232",
                            lineHeight: "1.55",
                          }}
                        >
                          {content.dataAnalysis?.title}
                        </div>
                        <Body2 color="gray700" style={{ color: "#666666" }}>
                          {getConceptName(content.designConcept)}
                        </Body2>
                      </ContentNameCell>
                    </td>
                    <td>
                      <Body2 color="gray700" align="left">
                        {(() => {
                          const dateStr = content.createDate;
                          if (!dateStr) return "-";
                          const match = dateStr.match(
                            /^(.+?)\s+(오전|오후)\s+(.+)$/
                          );
                          if (match) {
                            const datePart = match[1];
                            const amPm = match[2];
                            const timePart = match[3];
                            return (
                              <>
                                {datePart}
                                <br />
                                <Body2 color="gray700" align="left">
                                  {amPm} {timePart}
                                </Body2>
                              </>
                            );
                          }
                          return dateStr;
                        })()}
                      </Body2>
                    </td>
                    <td>
                      <ActionButtonsCell>
                        <ButtonGroup>
                          <PreviewButton
                            type="button"
                            onClick={() => handleTemplatePreview(content._id)}
                          >
                            <svg
                              width="21"
                              height="21"
                              viewBox="0 0 21 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.4991 4.9375C14.2651 4.9376 17.6532 7.00578 18.712 9.81836C18.8158 10.0941 18.8308 10.4038 18.7374 10.6992C18.0917 12.7392 15.547 15.4374 10.4991 15.4375C5.43073 15.4375 2.93409 12.476 2.27936 10.7217C2.17268 10.4358 2.17158 10.1309 2.25983 9.85352C2.7197 8.40882 3.86624 7.17982 5.3194 6.32129C6.77927 5.4589 8.5994 4.9375 10.4991 4.9375ZM10.4991 6.27051C8.83591 6.27051 7.25005 6.7295 5.99713 7.46973C4.73751 8.21395 3.86349 9.2112 3.53034 10.2578L3.52936 10.2598C4.00367 11.5242 6.02377 14.1045 10.4991 14.1045C15.0269 14.1044 17.0129 11.7269 17.4659 10.2988V10.2979C17.4658 10.2964 17.4657 10.2929 17.4639 10.2881C16.6478 8.12022 13.8568 6.27061 10.4991 6.27051ZM10.4991 7.02148C12.2479 7.02148 13.666 8.43867 13.6661 10.1875C13.6661 11.9364 12.248 13.3545 10.4991 13.3545C8.75034 13.3543 7.33307 11.9363 7.33307 10.1875C7.33316 8.43878 8.75039 7.02166 10.4991 7.02148ZM10.4991 8.35449C9.48677 8.35467 8.66617 9.17516 8.66608 10.1875C8.66608 11.1999 9.48671 12.0213 10.4991 12.0215C11.5116 12.0215 12.3331 11.2 12.3331 10.1875C12.333 9.17505 11.5116 8.35449 10.4991 8.35449Z"
                                fill="#666666"
                              />
                            </svg>
                            미리보기
                          </PreviewButton>
                          {/* <PopupButton onClick={() => handleOpenPopup(content._id)}>
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.2461 1.51953C11.549 1.51953 11.8136 1.72371 11.8906 2.0166L12.3047 3.5918L13.7861 4.20117L14.8652 3.2793C15.1297 3.05341 15.5235 3.06854 15.7695 3.31445L17.3691 4.91504C17.6142 5.1601 17.6309 5.55172 17.4072 5.81641L16.4893 6.90234L17.084 8.33887L18.6621 8.74023C18.9575 8.81535 19.1649 9.08099 19.165 9.38574V10.9678C19.165 11.2713 18.9597 11.5368 18.666 11.6133L17.0781 12.0264L16.4824 13.4648L17.4062 14.5547C17.6306 14.8193 17.6145 15.2127 17.3691 15.458L15.7695 17.0576C15.5191 17.308 15.1162 17.3185 14.8525 17.082L14.8086 17.043C14.7798 17.0173 14.7385 16.9798 14.6875 16.9346C14.5853 16.8439 14.4453 16.7207 14.2949 16.5898C14.121 16.4384 13.9438 16.2868 13.7959 16.1641L12.3457 16.7646L11.9443 18.3496C11.8694 18.6454 11.603 18.8525 11.2979 18.8525H9.69824C9.39301 18.8525 9.12661 18.6455 9.05176 18.3496L8.65137 16.7646L7.24414 16.1855L6.11914 17.1025C5.85403 17.3186 5.4684 17.2994 5.22656 17.0576L3.62695 15.458C3.37715 15.2082 3.36562 14.8067 3.60059 14.543L4.53223 13.4971L3.93066 12.0684L2.32227 11.6289C2.03252 11.5497 1.83115 11.2867 1.83105 10.9863V9.38574C1.83123 9.07608 2.04509 8.80769 2.34668 8.7373L3.9082 8.37207L4.49414 6.93164L3.58105 5.80664C3.36564 5.5415 3.3854 5.1566 3.62695 4.91504L5.22656 3.31445C5.47615 3.06496 5.87684 3.05367 6.14062 3.28809L7.19043 4.2207L8.61621 3.62012L9.03809 2.0166C9.11514 1.7238 9.37987 1.51963 9.68262 1.51953H11.2461ZM9.82227 4.27637C9.76963 4.47637 9.62709 4.64132 9.43652 4.72168L7.32031 5.61328C7.08353 5.713 6.81015 5.66783 6.61816 5.49707L5.72461 4.70215L4.99414 5.43262L5.77832 6.39648C5.93173 6.5853 5.96959 6.84301 5.87793 7.06836L5.01367 9.19434C4.93216 9.39473 4.75851 9.54355 4.54785 9.59277L3.16504 9.91504V10.4775L4.59473 10.8672C4.79213 10.9211 4.95371 11.0634 5.0332 11.252L5.9248 13.3672C6.02461 13.6041 5.97958 13.8773 5.80859 14.0693L5.01465 14.96L5.74414 15.6885L6.70996 14.9014C6.89955 14.747 7.15864 14.7087 7.38477 14.8018L9.46973 15.6592C9.6648 15.7395 9.81054 15.9078 9.8623 16.1123L10.2168 17.5195H10.7793L11.1357 16.1133C11.1874 15.9093 11.332 15.7417 11.5264 15.6611L13.6475 14.7822C13.8599 14.6944 14.103 14.7227 14.29 14.8564C14.4982 15.0053 14.8731 15.3256 15.1699 15.584C15.2038 15.6135 15.238 15.6425 15.2705 15.6709L15.9922 14.9492L15.2021 14.0166C15.0407 13.8261 14.9992 13.5608 15.0947 13.3301L15.9736 11.209C16.0536 11.0163 16.219 10.872 16.4209 10.8193L17.8311 10.4521V9.9043L16.4316 9.54883C16.2279 9.49701 16.0609 9.3515 15.9805 9.15723L15.1016 7.03711C15.0061 6.80662 15.0479 6.54206 15.209 6.35156L15.9932 5.42383L15.2627 4.69336L14.3428 5.47949C14.1526 5.64188 13.8875 5.68398 13.6562 5.58887L11.4912 4.69824C11.2979 4.61875 11.1527 4.45312 11.0996 4.25098L10.7324 2.85254H10.1963L9.82227 4.27637ZM10.499 7.01953C12.248 7.01953 13.666 8.43758 13.666 10.1865C13.6658 11.9353 12.2479 13.3525 10.499 13.3525C8.75034 13.3524 7.33318 11.9352 7.33301 10.1865C7.33301 8.43769 8.75023 7.01971 10.499 7.01953ZM10.499 8.35254C9.48661 8.35271 8.66602 9.17407 8.66602 10.1865C8.66619 11.1988 9.48672 12.0194 10.499 12.0195C11.5115 12.0195 12.3328 11.1989 12.333 10.1865C12.333 9.17396 11.5116 8.35254 10.499 8.35254Z"
                            fill="#226FFF"
                          />
                        </svg>
                        활성화 설정
                      </PopupButton> */}
                        </ButtonGroup>
                        <ButtonGroup>
                          {/* <EditButton
                          type="button"
                          onClick={() => handleEditTitle(content)}
                        >
                          <svg
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_222_5931)">
                              <path
                                d="M2.55835 14.504C2.52098 14.5415 2.5 14.5922 2.5 14.6452V17.4875C2.5 17.598 2.58954 17.6875 2.7 17.6875H5.54197C5.59512 17.6875 5.64609 17.6663 5.68362 17.6287L13.7001 9.58587C13.778 9.50773 13.7779 9.38127 13.6999 9.30326L10.8578 6.4611C10.7796 6.38291 10.6528 6.38301 10.5747 6.46133L2.55835 14.504ZM17.2583 6.05417C17.5833 5.72917 17.5833 5.20417 17.2583 4.87917L15.3083 2.92917C14.9833 2.60417 14.4583 2.60417 14.1333 2.92917L12.7498 4.31275C12.6716 4.39086 12.6717 4.51749 12.7498 4.5956L15.5919 7.43775C15.67 7.51586 15.7966 7.51586 15.8748 7.43775L17.2583 6.05417Z"
                                stroke="#666666"
                                strokeWidth="1.67"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_222_5931">
                                <rect
                                  width="20"
                                  height="20"
                                  fill="white"
                                  transform="translate(0 0.1875)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </EditButton> */}
                          {/* <DeleteButton
                          type="button"
                          onClick={() => {
                            setContentToDelete(content._id);
                            setShowConfirmPopup(true);
                          }}
                        >
                          <svg
                            width="20"
                            height="21"
                            viewBox="0 0 20 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <g clipPath="url(#clip0_992_2924)">
                              <path
                                d="M16.8364 3.70215C17.2366 3.70215 17.5618 4.02663 17.562 4.42676C17.562 4.82711 17.2368 5.15234 16.8364 5.15234H16.4419V15.3652C16.4419 17.367 14.8196 18.9902 12.8179 18.9902H6.71533C4.71361 18.9902 3.09131 17.367 3.09131 15.3652V5.15234H2.69678C2.29664 5.1521 1.97217 4.82695 1.97217 4.42676C1.97243 4.02678 2.2968 3.70239 2.69678 3.70215H16.8364ZM4.54053 5.15234V15.3652C4.54053 16.5663 5.5143 17.54 6.71533 17.54H12.8179C14.0189 17.54 14.9927 16.5663 14.9927 15.3652V5.15234H4.54053ZM8.24854 7.12402C8.64858 7.12419 8.97289 7.44861 8.97314 7.84863V14.5791C8.97314 14.9793 8.64874 15.3045 8.24854 15.3047C7.84819 15.3047 7.52295 14.9794 7.52295 14.5791V7.84863C7.52321 7.44851 7.84835 7.12402 8.24854 7.12402ZM11.2837 7.12402C11.6839 7.12402 12.009 7.44851 12.0093 7.84863V14.5791C12.0093 14.9794 11.684 15.3047 11.2837 15.3047C10.8835 15.3045 10.5591 14.9794 10.5591 14.5791V7.84863C10.5593 7.4486 10.8836 7.12417 11.2837 7.12402ZM12.064 0.988281C12.4641 0.988474 12.7884 1.31279 12.7886 1.71289C12.7886 2.11312 12.4641 2.43828 12.064 2.43848H7.47119C7.07096 2.43834 6.74658 2.11315 6.74658 1.71289C6.74674 1.31276 7.07106 0.988422 7.47119 0.988281H12.064Z"
                                fill="#666666"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_992_2924">
                                <rect
                                  width="20"
                                  height="21"
                                  fill="white"
                                  transform="translate(0 0.1875)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </DeleteButton> */}
                        </ButtonGroup>
                      </ActionButtonsCell>
                    </td>
                  </tr>
                ))}
              </TableBody>
            </Table>
          )}
        </ContentListWrap>
        {isPopupOpen && (
          <MoleculeContentPopup
            onClose={handleClosePopup}
            contentList={filteredContentListForPopup}
            selectedTab={selectedTab}
            lotationDetail={lotationDetail}
            onLotationUpdate={onLotationUpdate}
          />
        )}
        {showContentSettingPopup && (
          <MoleculeContentSettingPopup
            onClose={handleCloseContentSettingPopup}
            lotationDetail={lotationDetail}
            onUpdate={onLotationUpdate}
          />
        )}
        {showConfirmPopup && contentToDelete && (
          <PopupWrap
            Warning
            title="정말 삭제 하시겠습니까?"
            message={<>해당 콘텐츠가 삭제됩니다.</>}
            buttonType="Outline"
            closeText="취소"
            confirmText="삭제"
            isModal={false}
            onCancel={() => {
              setShowConfirmPopup(false);
              setContentToDelete(null);
            }}
            onConfirm={() => handleDeleteContent(contentToDelete)}
          />
        )}

        {/* 복사 성공 팝업 */}
        {showCopySuccessPopup && (
          <PopupWrap
            Check
            title="클립보드에 복사가 완료되었습니다."
            message={
              copiedInfo.type === "오류"
                ? copiedInfo.content
                : `${copiedInfo.type}가 클립보드에 복사되었습니다.`
            }
            buttonType="Outline"
            confirmText="확인"
            isModal={false}
            onConfirm={() => {
              setShowCopySuccessPopup(false);
              setCopiedInfo({ type: "", content: "" });
            }}
          />
        )}
      </Container>

      {/* 미리보기 컴포넌트 */}
      {showTemplatePreview &&
        (contentsTypeState === "meal" ? (
          <OrganismDisplayViewEduMealPreview
            template={templateToPreview}
            onClose={handleCloseTemplatePreview}
            title={templateToPreview?.title}
            mealData={previewMealData}
            noticeText={previewNoticeText}
            displayWidth={previewWidth}
            displayHeight={previewHeight}
          />
        ) : (
          <OrganismDisplayViewEduPreview
            template={templateToPreview}
            onClose={handleCloseTemplatePreview}
            title={templateToPreview?.title}
            jsonData={previewJsonData}
            contentsPurpose={previewContentsPurpose}
            contentsDesignConcept={previewContentsDesignConcept}
            markdownData={previewMarkdownData}
            titleData={previewTitleData}
            displayWidth={previewWidth}
            displayHeight={previewHeight}
          />
        ))}
    </>
  );
};

export default OrganismContentList;

const Container = styled.div`
  width: 1240px;
  background: white;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 0px 20px 0px;
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 30px;
`;

const YearMonth = styled.span`
  color: #323232;
  font-size: 36px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 36px;
`;

const TabContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px;
  background: #eef2f7;
  border-radius: 24px;
`;

const Tab = styled.button`
  height: 40px;
  min-width: 69px;
  padding: 4px 27px;
  background: ${(props) => (props.active ? "white" : "transparent")};
  border: 1px solid ${(props) => (props.active ? "#256EF4" : "transparent")};
  border-radius: 24px;
  cursor: pointer;
  color: #323232;
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
  transition: all 0.2s ease;

  &:hover {
    background: ${(props) =>
      props.active ? "white" : "rgba(255, 255, 255, 0.5)"};
  }
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ContentListWrap = styled.div`
  width: 100%;
`;

const Table = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  background: ${palette.white};
  overflow: hidden;
`;

const TableHeader = styled.thead`
  background: #eef2f7;

  th {
    padding: 20px 16px;
    border-bottom: 1px solid ${palette.outlineGray};
  }
`;

const TableBody = styled.tbody`
  tr {
    &:hover {
      background: #f9fafb;
    }
    border-bottom: 1px solid ${palette.outlineGray};
  }

  td {
    padding: 20px 16px;
  }
`;

const PopupButton = styled.button`
  background: ${palette.brightBlue};
  color: ${palette.primary};
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;

  &:hover {
    background: ${palette.brightBlue}DD;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-start;
  gap: 20px;
`;

const PreviewButton = styled.button`
  background: ${palette.gray100};
  color: ${palette.gray700};
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  &:hover {
    background: ${palette.gray200};
  }
`;

const EditButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;

const DeleteButton = styled.button`
  color: #666666;
  border: none;
  padding: 4px 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;

  &:hover {
    svg {
      path {
        fill: rgb(73, 73, 73);
      }
    }
  }
`;

const ContentNameCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
`;

const ActionButtonsCell = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
`;

// 다이렉트 링크 관련 스타일드 컴포넌트들
const DirectLinkContainer = styled.div`
  margin-left: 0px;
`;

const StyledFrame = styled.div`
  align-self: stretch;
  justify-content: flex-start;
  align-items: center;
  display: inline-flex;
`;

const StyledIdSpan01 = styled.span`
  color: var(--color-text-subtle, #464c53);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const StyledIdSpan02 = styled.span`
  color: var(--color-text-primary, #0b50d0);
  font-size: 17px;
  font-family: Pretendard;
  font-weight: 700;
  line-height: 25.5px;
  word-wrap: break-word;
`;

const CopyButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: ${palette.gray100};
  }
`;

const StyledContentButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #e6f0ff !important;
  }
`;
